import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import Loader from "../helper/Loader";

const Contact = () => {
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState({ type: "", text: "" }); // { type: 'success'|'error', text: string }

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      mobile: "",
      subject: "",
      message: "",
    },

    validationSchema: Yup.object({
      name: Yup.string().required("Required"),
      email: Yup.string().email("Invalid").required("Required"),
      mobile: Yup.string()
        .matches(/^[0-9]{7,15}$/, "Invalid")
        .required("Required"),
      subject: Yup.string().required("Required"),
      message: Yup.string().required("Required"),
    }),

    onSubmit: async (values, { resetForm }) => {
      setMsg({ type: "", text: "" });
      setLoading(true);

      try {
        const res = await axios.post("http://localhost:3034/contacts", values);

        setMsg({
          type: "success",
          text: res.data?.message || "Message submitted successfully!",
        });

        resetForm();
      } catch (err) {
        setMsg({
          type: "error",
          text: err.response?.data?.error || "Failed to submit message.",
        });
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <>
      {loading && <Loader />}

      <section
        className="contact py-80"
        style={{ opacity: loading ? 0.3 : 1, pointerEvents: loading ? "none" : "auto" }}
      >
        <div className="container container-lg">
          <div className="row gy-5">
            <div className="col-lg-8">
              <div className="contact-box border border-gray-100 rounded-16 px-24 py-40">
                {/* Success / Error message box */}
                {msg.text && (
                  <div
                    style={{
                      padding: "12px 16px",
                      marginBottom: 16,
                      borderRadius: 8,
                      fontWeight: 600,
                      color: msg.type === "success" ? "#155724" : "#721c24",
                      background: msg.type === "success" ? "#d4edda" : "#f8d7da",
                      border: msg.type === "success" ? "1px solid #c3e6cb" : "1px solid #f5c6cb",
                    }}
                  >
                    {msg.text}
                  </div>
                )}

                <form onSubmit={formik.handleSubmit}>
                  <h6 className="mb-32">Make Custom Request or Contact for issues</h6>

                  <div className="row gy-4">
                    {/* NAME */}
                    <div className="col-sm-6 col-xs-6">
                      <label
                        htmlFor="name"
                        className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                      >
                        Full Name <span className="text-danger text-xl line-height-1">*</span>
                      </label>
                      <input
                        type="text"
                        className="common-input px-16"
                        id="name"
                        name="name"
                        placeholder="Full name"
                        {...formik.getFieldProps("name")}
                      />
                      {formik.touched.name && formik.errors.name && (
                        <small className="text-danger">{formik.errors.name}</small>
                      )}
                    </div>

                    {/* EMAIL */}
                    <div className="col-sm-6 col-xs-6">
                      <label
                        htmlFor="email"
                        className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                      >
                        Email Address <span className="text-danger text-xl line-height-1">*</span>
                      </label>
                      <input
                        type="email"
                        className="common-input px-16"
                        id="email"
                        name="email"
                        placeholder="Email address"
                        {...formik.getFieldProps("email")}
                      />
                      {formik.touched.email && formik.errors.email && (
                        <small className="text-danger">{formik.errors.email}</small>
                      )}
                    </div>

                    {/* MOBILE */}
                    <div className="col-sm-6 col-xs-6">
                      <label
                        htmlFor="mobile"
                        className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                      >
                        Phone Number <span className="text-danger text-xl line-height-1">*</span>
                      </label>
                      <input
                        type="text"
                        className="common-input px-16"
                        id="mobile"
                        name="mobile"
                        placeholder="Phone Number*"
                        {...formik.getFieldProps("mobile")}
                      />
                      {formik.touched.mobile && formik.errors.mobile && (
                        <small className="text-danger">{formik.errors.mobile}</small>
                      )}
                    </div>

                    {/* SUBJECT */}
                    <div className="col-sm-6 col-xs-6">
                      <label
                        htmlFor="subject"
                        className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                      >
                        Subject <span className="text-danger text-xl line-height-1">*</span>
                      </label>
                      <input
                        type="text"
                        className="common-input px-16"
                        id="subject"
                        name="subject"
                        placeholder="Subject"
                        {...formik.getFieldProps("subject")}
                      />
                      {formik.touched.subject && formik.errors.subject && (
                        <small className="text-danger">{formik.errors.subject}</small>
                      )}
                    </div>

                    {/* MESSAGE */}
                    <div className="col-sm-12">
                      <label
                        htmlFor="message"
                        className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                      >
                        Message <span className="text-danger text-xl line-height-1">*</span>
                      </label>
                      <textarea
                        className="common-input px-16"
                        id="message"
                        name="message"
                        placeholder="Type your message"
                        rows={5}
                        {...formik.getFieldProps("message")}
                      />
                      {formik.touched.message && formik.errors.message && (
                        <small className="text-danger">{formik.errors.message}</small>
                      )}
                    </div>

                    {/* BUTTON */}
                    <div className="col-sm-12 mt-32">
                      <button
                        type="submit"
                        className="btn btn-main py-18 px-32 rounded-8"
                        disabled={loading}
                      >
                        {loading ? "Submitting..." : "Get a Quote"}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            {/* RIGHT SIDE BOX (UNCHANGED) */}
            <div className="col-lg-4">
              <div className="contact-box border border-gray-100 rounded-16 px-24 py-40">
                <h6 className="mb-48">Get In Touch</h6>
                <div className="flex-align gap-16 mb-16">
                  <span className="w-40 h-40 flex-center rounded-circle border border-gray-100 text-main-two-600 text-2xl flex-shrink-0">
                    <i className="ph-fill ph-phone-call" />
                  </span>
                  <Link
                    to="/tel:+916359667777"
                    className="text-md text-gray-900 hover-text-main-600"
                  >
                  +916359667777
                  </Link>
                </div>
                <div className="flex-align gap-16 mb-16">
                  <span className="w-40 h-40 flex-center rounded-circle border border-gray-100 text-main-two-600 text-2xl flex-shrink-0">
                    <i className="ph-fill ph-envelope" />
                  </span>
                  <Link
                    to="/mailto:support@durgaenterpriseglobal.com"
                    className="text-md text-gray-900 hover-text-main-600"
                  >
                    info@durgaenterpriseglobal.com
                  </Link>
                </div>
                <div className="flex-align gap-16 mb-0">
                  <span className="w-40 h-40 flex-center rounded-circle border border-gray-100 text-main-two-600 text-2xl flex-shrink-0">
                    <i className="ph-fill ph-map-pin" />
                  </span>
                  <span className="text-md text-gray-900 ">
                    789 Inner Lane, California, USA
                  </span>
                </div>
              </div>
              <div className="mt-24 flex-align flex-wrap gap-16">
                <Link to="/tel:+916359667777"
                  className="bg-neutral-600 hover-bg-main-600 rounded-8 p-10 px-16 flex-between flex-wrap gap-8 flex-grow-1"
                >
                  <span className="text-white fw-medium" >Get Support On Call</span>
                  <span className="w-36 h-36 bg-main-600 rounded-8 flex-center text-xl text-white">
                    <i className="ph ph-headset" />
                  </span>
                </Link>
                <Link
                  to="#"
                  className="bg-neutral-600 hover-bg-main-600 rounded-8 p-10 px-16 flex-between flex-wrap gap-8 flex-grow-1"
                >
                  <span className="text-white fw-medium">Get Direction</span>
                  <span className="w-36 h-36 bg-main-600 rounded-8 flex-center text-xl text-white">
                    <i className="ph ph-map-pin" />
                  </span>
                </Link>
              </div>
            </div>
            {/* end right side */}
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
